"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerClipRenderType = void 0;
var ProducerClipRenderType;
(function (ProducerClipRenderType) {
    ProducerClipRenderType["Ceremony"] = "Ceremony";
    ProducerClipRenderType["Students"] = "Students";
})(ProducerClipRenderType = exports.ProducerClipRenderType || (exports.ProducerClipRenderType = {}));
//# sourceMappingURL=producer-clip-render-type.js.map